// extracted by mini-css-extract-plugin
export default {"page-wrapper":"Page_page-wrapper__-hJPm","pageWrapper":"Page_page-wrapper__-hJPm","page-background":"Page_page-background__raHTE","pageBackground":"Page_page-background__raHTE"};